import React from 'react';
var defaultMatchHeightContext = {};
export var MatchHeightContext = /*#__PURE__*/React.createContext(defaultMatchHeightContext);